import { FlexibleConnectedPositionStrategy, GlobalPositionStrategy, Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { Injector } from '@angular/core';
import { Calendar } from '@fullcalendar/angular';
import { Subject, takeUntil } from 'rxjs';
import { PostItComponent } from 'src/app/modules/shared/components/postit/postit.component';
import { CONTAINER_DATA } from 'src/app/modules/shared/injector.token';
import { EventModel } from 'src/app/modules/shared/models/event.model';
import { Converters } from 'src/app/modules/shared/utils/converters.utils';
import { MessageModel } from '../../messages/models/message.model';
import { EventPopoverComponent } from '../components/event-popover/event-popover.component';

export class DialogUtils {

  static openEventOverlay(event: any, ref: any, x = 0, y = 0, _overlay: Overlay, unsubscribe: Subject<any>,
    overlayRef: OverlayRef, injector: Injector, calendarApi: Calendar, utenti: any, calendars: any,
    hasToUpdateCalendar = true): void {
    const scrollStrategy = _overlay.scrollStrategies.reposition();
    let positionStrategy: FlexibleConnectedPositionStrategy | GlobalPositionStrategy;

    if (ref) {
      positionStrategy = _overlay.position().flexibleConnectedTo(
        ref).withPositions([{
          originX: 'start',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'top',
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'top',
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'end',
          overlayY: 'bottom',
        },
        {
          originX: 'start',
          originY: 'top',
          overlayX: 'start',
          overlayY: 'bottom',
        }])
        .withPush(false);
    } else {
      const DIALOG_W = 550;
      const DIALOG_H = 600;
      const GAP = 12; // distanza dal puntatore

      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const sx = window.scrollX;
      const sy = window.scrollY;

      // Se vicino al bordo destro/basso, apri a sinistra/sopra del cursore
      const overRight = x + DIALOG_W + GAP > vw;
      const overBottom = y + DIALOG_H + GAP > vh;

      let left = sx + (overRight ? x - DIALOG_W - GAP : x + GAP);
      let top = sy + (overBottom ? y - DIALOG_H - GAP : y + GAP);

      // Clamp per non uscire dal viewport
      left = 1000;
      top = 200;

      positionStrategy = _overlay.position()
        .global()
        .left(`${left}px`)
        .top(`${top}px`);
    }

    overlayRef = _overlay.create({
      positionStrategy,
      scrollStrategy,
      hasBackdrop: true,
      width: '550px',
      minWidth: '550px'
    });

    overlayRef
      .backdropClick()
      .pipe(takeUntil(unsubscribe))
      .subscribe(() => {
        DialogUtils.detachOverlay(overlayRef);
      });

    overlayRef.detachments().subscribe(() => {
      // this.updateEvents();
    });
    const currentEvent: EventModel = event.id ? event : new EventModel();
    currentEvent.dataInizio = Converters.fromDateToNgbDateStruct(event.date);
    const userProfilePortal = new ComponentPortal(EventPopoverComponent, null, Injector.create({
      parent: injector,
      providers: [
        {
          provide: CONTAINER_DATA, useValue: {
            currentEvent, overlayRef, calendarApi,
            utenti, calendars, hasToUpdateCalendar
          }
        }
      ]
    }));
    const component = overlayRef.attach(userProfilePortal);
    component.instance.isLoadingEmitter.subscribe((isLoading) => {
      isLoading = isLoading;
    });
  }

  static openPostItOverlay(event: any, x = -300, y = -280, _overlay: Overlay, injector: Injector, messageId: any, title: string, body: string, message: MessageModel): OverlayRef {
    const scrollStrategy = _overlay.scrollStrategies.reposition();
    let positionStrategy: FlexibleConnectedPositionStrategy | GlobalPositionStrategy;

    let overlayRef!: OverlayRef;
    let unsubscribe = new Subject();

    positionStrategy = _overlay.position().global().right(`${x + Math.floor(Math.random() * 100)}px`).top(`${y + Math.floor(Math.random() * 100)}px`);

    overlayRef = _overlay.create({
      positionStrategy,
      scrollStrategy,
      hasBackdrop: false,
    });

    overlayRef
      .backdropClick()
      .pipe(takeUntil(unsubscribe))
      .subscribe(() => {
        // DialogUtils.detachOverlay(overlayRef);
      });

    overlayRef.detachments().subscribe(() => {
      // this.updateEvents();
    });

    const userProfilePortal = new ComponentPortal(PostItComponent, null, Injector.create({
      parent: injector,
      providers: [
        {
          provide: CONTAINER_DATA, useValue: {
            overlayRef, messageId, title, body, message
          }
        }
      ]
    }));
    const component = overlayRef.attach(userProfilePortal);
    return overlayRef;
  }

  static detachOverlay(overlayRef: OverlayRef,): void {
    if (overlayRef.hasAttached()) {
      overlayRef.detach();
    }
  }




}
